import React from 'react';
import { Icon, Row, Col } from 'antd';

interface IProp {
	title: any
	collapsed: boolean
	ticket: any
}

class BodyTitleComponent extends React.Component<IProp, {}> {

	render(): JSX.Element {

		return (
			<Row>
				<Col sm={8} md={8} xl={8}>
					<h4>{this.props.title}
					</h4>

				</Col>
				{this.props.ticket &&
					<Col sm={8} md={8} xl={8}>
						{
							(this.props.collapsed &&
								<Icon type="caret-up" />
							)
						}
						{
							(!this.props.collapsed &&
								<Icon type="caret-down" />
							)
						}
					</Col>
				}
			</Row>
			// <span>  </span>

		);
	}
};

export default BodyTitleComponent;
